import { UrlConfig, AppConfig } from 'config';
import { AjaxService } from 'services';
import { ApiResponse } from 'models/Api/ApiResponse';
import { PaginationModel } from 'models';
import { ItemSuggestedListingModel } from 'models/ItemSuggestedListings/ItemSuggestedListings';
import { RawPaginationData } from 'models/Pagination/Pagination';
import { RawItemSuggestedListing } from 'models/ItemSuggestedListings/types';
import { JSONObject } from 'models/Api/types';

export class ItemSuggestedListingsApiClient {
  public static async getSuggestedListings(itemId: string, params: JSONObject = {}): Promise<PaginationModel<ItemSuggestedListingModel>> {
    const url = UrlConfig.ITEM_SUGGESTION.ITEM_SUGGESTED_LISTINGS(itemId);
    const response: ApiResponse<RawPaginationData<RawItemSuggestedListing>> = await AjaxService.getData(url, {
      ...params,
      min_score: 0.9
    });
    const paginatedResponse: PaginationModel<RawItemSuggestedListing> = new PaginationModel(response.data);
    const suggestions = paginatedResponse.data.map((rawSuggestion: RawItemSuggestedListing) => new ItemSuggestedListingModel(rawSuggestion));
    return new PaginationModel<ItemSuggestedListingModel>({
      ...response.data,
      data: suggestions,
      fetched: true
    });
  }

  public static async recomputeItemSuggestions(itemId: string): Promise<void> {
    if (!AppConfig.API.INTELLIGENCE_API_KEY) {
      throw new Error('Missing REACT_APP_INTELLIGENCE_API_KEY');
    }

    const url = UrlConfig.ITEM_SUGGESTION.RECOMPUTE_ITEM_SUGGESTIONS(itemId);
    await AjaxService.postData(
      url,
      {},
      false,
      false,
      false,
      { 'X-API-Key': AppConfig.API.INTELLIGENCE_API_KEY }
    );
  }
}
